import React from 'react';
import Service from './Service.jsx'
import Skill from './Skill.jsx'
import { compose } from 'redux';
import { connect } from 'react-redux';
import background from '../../images/background-blue.png';
import { firebaseConnect } from 'react-redux-firebase'
import { withRouter } from 'react-router'
import ChangePassword from '../../components/ChangePassword';
import Terms_Conditions from '../../components/Terms_Conditions';
import { translate } from 'react-i18next';
import { pathOr } from 'ramda'
import moment from 'moment'
import { serviceTracker_allowed } from '../../config.js'
import { message, Modal } from 'antd'
import { fbFunctionsURL } from '../../config.js';
import axios from 'axios'

class StudentApp extends React.Component {

  state = {
    product: null,
    termsModal: false,
    changePass: false,
    hasPopup: false
  }

  componentDidMount = () => {
    this.redirectToProduct()
    this.checkTerms()
  }

  redirectToProduct = () => {
    if (!serviceTracker_allowed && profile && profile.termsAccepted && !profile.profile.changePassword) {
      return this.setState({product: 'SkillTracker'})
    }

    const { products, lastUsed, profile } = this.props
    let product;
    if (products && lastUsed && profile && profile.termsAccepted && !profile.profile.changePassword) {
      product = lastUsed
    } else if (products && profile && profile.termsAccepted && !profile.profile.changePassword) {
      product = products.length == 1 ? products[0] : 'SkillTracker'
    }

    if (!this.state.product && product) {
      this.setState({product})
    }
  }

  componentDidUpdate = (prevProps) => {
    this.redirectToProduct()
    this.checkTerms()

  }

  checkTerms = () => {

    if (!this.state.termsModal && this.props.profile && !this.props.profile.termsAccepted) {
      console.log('this one');
      this.setState({termsModal: true})
    } else if (!this.state.termsModal && !this.state.changePass && this.props.profile && !this.props.profile.changePassword) {
      this.setState({changePass: true})
    }

  }

  switchProduct = (product) => {
    this.setState({product})
    const { uid } = this.props
    this.props.firebase.database().ref(`/users/${uid}/profile`).update({
      lastUsed: product
    })
  }

  changePass = (psw) => {
    const _this = this
    const email = this.props.firebase.auth().currentUser.email
    const { uid, profile } = this.props
    const token = profile.token
    let user = this.props.firebase.auth().currentUser;
    this.props.firebase.auth().currentUser.getIdToken()
      .then(token => {
        const config = {
          url: `${fbFunctionsURL}/register/changePassword`,
          method: 'post',
          data: {
            password: psw,
            uid
          },
          headers: {
            authorization: `Bearer ${token}`
          }
        }
        axios(config)
          .then(() => {
            message.success('Password saved')
            _this.props.firebase.database().ref(`/users/${uid}/token`).remove()
            _this.props.firebase.database().ref(`/users/${uid}/profile/changePassword`).remove()
            _this.setState({ changePass: false })
            _this.props.history.push('/welcome')
          }).catch(function (error) {
            message.error(error.message)
          });
      })

  }

  acceptTerms = () => {
    const {uid} = this.props
    this.props.firebase.database().ref(`users/${uid}`).update({
      termsAccepted: true
    })
    this.setState({termsModal: false, changePass: true})
  }

  isSubscriptionValid = () => {
    let subscriptions = pathOr([], ['profile', 'subscription', 'products'], this.props)
    let currentTimestamp = moment().valueOf()
    let validItems = subscriptions.filter( item => {
      let expiresAt = moment(item.purchase.transactionDate).add(13, 'months')
      if (expiresAt > currentTimestamp) {
        return true
      } else {
        return false
      }
    })
    return validItems.length > 0 ? true : false
  }

  displaySubsriptionWarning = () => {
    if (!this.state.hasPopup) {
      this.setState({hasPopup: true})
      Modal.warning({
        title: "You don't have an active subscription",
        content: 'Please subscribe from the mobile app in order to continue using service tracker.',
        okText: 'Log out',
        onOk: () => this.props.firebase.logout()
      });
    }
  }


  render() {
    const { product } = this.state
    const isSelfSignUp = pathOr(false, ['profile', 'isSelfSignedUp'] , this.props)
    let isSubscriptionValid = isSelfSignUp && this.isSubscriptionValid()

    if (isSelfSignUp && !isSubscriptionValid) {
      this.displaySubsriptionWarning()
      return (
        <div style={BackgroundStyle}>
        </div>
      )
    } else if (isSelfSignUp || product == 'ServiceTracker') {
      return <Service products={this.props.products} switchProduct={this.switchProduct} isSelfSignUp={isSelfSignUp} />
    } else if (product == 'SkillTracker') {
      return <Skill products={this.props.products} changeLanguage={this.props.changeLanguage} switchProduct={this.switchProduct} />
    } else {
      return (
      <div style={BackgroundStyle}>
      
        <ChangePassword
          open={this.state.changePass}
          color={'#006588'}
          changePass={this.changePass}
          t={this.props.t}
        />
        <Terms_Conditions
          mode={'student'}
          open={this.state.termsModal}
          acceptTerms={this.acceptTerms}
          mode="student"
          t={this.props.t}
        />
      </div>
    )
    }
  }
}

const enhancer = compose(
  translate(['view', 'nav'], { wait: true }),
  firebaseConnect(),
  connect(
    state => {
      return {
        products: pathOr(['SkillTracker'], ['profile', 'profile', 'products'], state.firebase),
        lastUsed: pathOr(null, ['profile', 'profile', 'lastUsed'], state.firebase),
        uid: pathOr(null, ['auth', 'uid'], state.firebase),
        profile: state.firebase.profile || {},
      }
    }
  )
)
export default withRouter(enhancer(StudentApp))

const BackgroundStyle =  {
  backgroundImage: `url(${background})`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  minHeight: '100vh',
  minWidth: '100vw',
}



// WEBPACK FOOTER //
// ./src/containers/StudentApp/index.jsx